/* eslint-disable */
export default function () {
  return {
    statusOperator: true,
    fetchSearch: false,
    // allRooms: [],
    // filteredRooms: [],
  }
}
